module.exports = __webpack_public_path__ + "img/9788956372709.71f5e133.jpg";